import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackendSessionService {
  protected api: string;

  constructor(protected http: HttpClient, appConfigService: AppConfigService) {
    this.api = appConfigService.getApi();
  }

  open(concept: string): Observable<string> {
    return this.http.post<string>(`${this.api}/session`, { concept });
  }

  close(id: string): Observable<any> {
    return this.http.delete(`${this.api}/session/${id}`);
  }
}
